import { useAuth } from 'modules/auth/ui/hooks/use-auth';
import { OrganizerUpsertPayload } from 'modules/organizer/domain/interfaces/organizer-upsert-payload';
import { UpsertOrganizerInput } from 'modules/organizer/domain/interfaces/upsert-organizer-input';
import { upsertOrganizer } from 'modules/organizer/store/orginizer/actions';
import { OrganizerForm } from 'modules/organizer/ui/components/organizer-form';
import UDText from 'ud-ui/components/text';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store/store';
import UDHeaderTitle from 'ud-ui/components/header-title';
import { useMainLayout } from 'ud-ui/layout/main/context';
import { Organizer } from 'modules/organizer/domain/interfaces/organizer';
import { switchUserTournament } from 'modules/auth/store/actions';

const OrganizerCreatePage = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user } = useAuth();
  const { setHeaderContent } = useMainLayout();
  const initData = { phone: user?.phone } as Organizer;

  const createOrganizer = useCallback(
    (data: OrganizerUpsertPayload) => {
      const { logo, ...restData } = data;

      const params = {
        ...restData,
        adminUserId: user!.id,
        sportType: data.sportType.toString().toUpperCase(),
        logo: logo && logo[0].img instanceof File ? logo[0].img : undefined,
        background: logo && logo[0] ? logo[0].background : undefined,
      } as UpsertOrganizerInput;

      dispatch(upsertOrganizer(params))
        .unwrap()
        .then(async (result) => {
          dispatch(switchUserTournament(result.id));
        });
    },
    [dispatch, user],
  );

  useEffect(() => {
    setHeaderContent(<UDHeaderTitle>Создание организатора</UDHeaderTitle>);
    return () => setHeaderContent(null);
  }, [setHeaderContent]);

  return (
    <>
      <div className="container py-6">
        <UDText type="headline" className="mr-10">
          Информация об организаторе
        </UDText>
      </div>
      <div className="d-flex align-items-center bb-1 container" />
      <div className="container py-6">
        <OrganizerForm onSubmit={createOrganizer} initialValues={initData} />
      </div>
    </>
  );
};

export default OrganizerCreatePage;
